import React, { useState, useEffect } from 'react'
import cx from 'classnames'
import { useBoolean } from 'ahooks-v2'
import styles from './RegionItem.module.less'

interface IProps {
  onSelectIndex: (index: number) => void;

  dataSource: {
    selectedIndex: number;
    hotRegions: number[];
    regions: {
      id: number;
      name: string;
    }[];
    parts: {
      name: string;
      regions: number[];
    }[]
  }
}

const RegionItem = ({ dataSource, onClearSelect, onSelectIndex }: IProps) => {
  const [selected, setSelect] = useState("請選擇地區");
  const [state, { toggle }] = useBoolean(false);

  useEffect(() => {
    Object.keys(dataSource).length !== 0 && dataSource.regions.map((v, i) => {
      if (i === dataSource.selectedIndex) {
        setSelect(v.name)
      }
    })
  }, [dataSource])

  return (
    <section className={styles['RegionItem']}>
      <div className={styles['ask-label']}>地<i style={{ marginLeft: "28px" }} />區：</div>
      <div className={styles['selcet-item-border']} onClick={() => {
        if (Object.keys(dataSource).length === 0 || dataSource.regions.length === 0) {
          onClearSelect();
          return
        }
        toggle()
      }}>
        <i className={cx(styles['arrow-icon'], {
          [styles['action']]: state
        })} />
        {selected}
      </div>
      {state &&
        <section className={styles['select-region-item']}>
          {Object.keys(dataSource).length !== 0 && dataSource.parts.map((v, i: number) => (
            <div className={styles['block']} key={i}>
              <label>{v.name}</label>
              <ul>
                {Array.isArray(v.regions) && v.regions.map((vv: any, ii: number) => (
                  <li
                    className={
                      cx({ [styles['press']]: dataSource.selectedIndex === vv })
                    }
                    key={ii}
                    onClick={() => {
                      onSelectIndex(vv)
                      toggle()
                    }}
                  >
                    {dataSource.regions[vv].name}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </section>
      }
    </section>
  )
}



export default RegionItem